import { lazy } from 'react';

import {
  createRootRouteWithContext,
  Outlet,
  redirect,
} from '@tanstack/react-router';

import { RouterContext } from '@/app/router';
import {
  getAuthSession,
  isSessionExpiringSoon,
  setLoginRedirectUri,
} from '@/features/auth';
import { Error } from '@/shared/components/layouts';

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      }))
    );

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ location }) => {
    if (location.pathname.startsWith('/auth/')) {
      return;
    }

    const session = await getAuthSession();
    if (!session || isSessionExpiringSoon(session.expires_at)) {
      setLoginRedirectUri(location.href);
      redirect({ to: '/auth/login', replace: true, throw: true });
    }
  },

  component: RootComponent,

  errorComponent: ({ error }) => <Error error={error} />,
});

function RootComponent() {
  return (
    <>
      <TanStackRouterDevtools position='bottom-right' />
      <Outlet />
    </>
  );
}
